<template>
  <div class="dashboard-page summary-page">
    <section class="summary-page__content">
      <div class="summary-page__card">
        <transition name="fade" mode="out-in">
          <StatsCard />
        </transition>
      </div>

      <div v-if="userRole === 'employe'" class="summary-page__card">
        <transition name="fade" mode="out-in">
          <StatsEmploye />
        </transition>
      </div>
      <div v-if="userRole === 'admin'" class="summary-page__card">
        <transition name="fade" mode="out-in">
          <StatsAdmin />
        </transition>
        <transition name="fade" mode="out-in">
          <AdminAnalysesList />
        </transition>
        <transition name="fade" mode="out-in">
          <ClientStandardList />
        </transition>
      </div>
    </section>
  </div>
  </template>
  
  <script>
  import StatsCard from '@/components/patrimoine/StatsCard.vue';
  import ClientStandardList from '@/components/patrimoine/ClientStandardList.vue';
  import StatsAdmin from '@/components/patrimoine/StatsAdmin.vue';
import StatsEmploye from '@/components/patrimoine/StatsEmploye.vue';
import AdminAnalysesList from '@/components/patrimoine/AdminAnalysesList.vue';
import { getUserRole, refreshProfileFromApi } from '@/utils/auth';

  export default {
    components: {
      StatsCard,
      StatsAdmin,
      StatsEmploye,
      ClientStandardList,
      AdminAnalysesList
    },
    data() {
      return {
        completed: 0,
        inProgress: 0,
        notStarted: 0,
        profileRevision: 0,
      };
    },
    computed: {
      userRole() {
        void this.profileRevision;
        return getUserRole() || '';
      },
    },
    async mounted() {
      await refreshProfileFromApi();
      this.profileRevision += 1;
      this.fetchSummary();
    },
    methods: {
      async fetchSummary() {
        // const response = await fetch('/api/summary/');
        // const summary = await response.json();
        // this.completed = summary.completed;
        // this.inProgress = summary.inProgress;
        // this.notStarted = summary.notStarted;
      },
    },
  };
  </script>
  
  <style scoped>
  /* Aligner cette page sur le look & feel dashboard */
  .summary-page {
    min-height: auto;
    background: transparent;
    padding: clamp(0.5rem, 2vw, 1rem);
    font-family: var(--font-body);
  }

  .summary-page__content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    min-width: 0;
    width: 100%;
  }

  .summary-page__card {
    background: var(--paper);
    border: 1px solid var(--line);
    border-radius: var(--radius-card);
    box-shadow: var(--shadow-sm);
    padding: 1.25rem;
    min-width: 0;
  }

  /* Transition cohérente avec le reste */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.2s ease;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
  </style>